import Styles from 'src/components/Styles';

export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    gradientBackground: {
      flex: 1,
    },
    title: {
      fontWeight: '400',
      fontSize: Styles.Fonts.sectionHeader,
      textAlign: 'center',
      color: Styles.Colors.PayNew.black01,
    },
    youGotText: {
      fontSize: Styles.Fonts.sectionHeader,
      fontWeight: '400',
      textAlign: 'center',
      color: Styles.Colors.PayNew.black01,
      lineHeight: 20,
    },
    amount: {
      fontSize: Styles.Fonts.f6 - 3.34,
      fontWeight: '700',
      paddingVertical: Styles.Spacing.m3,
      textAlign: 'center',
    },
    text: {
      color: Styles.Colors.PayNew.black01,
      fontSize: Styles.Fonts.sectionHeader,
      textAlign: 'center',
      fontWeight: '400',
    },
    buttonStyle: {
      marginTop: 60,
      alignSelf: 'center',
      justifyContent: 'center',
    },
    hometext: {
      textAlign: 'center',
      fontSize: Styles.Fonts.f7,
      fontWeight: '700',
    },
  };
}

export default {
  getStyleDescriptor,
};
